import React from "react";
import ReactDOM from "react-dom/client";
import "bootstrap/dist/css/bootstrap.min.css";
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";


import { PublicClientApplication } from "@azure/msal-browser";
import store from "./Redux/store";
import { Provider } from "react-redux";
import "./Axios/Axios";
import { msalConfig } from "./Office365/authConfig";

export const msalInstance = new PublicClientApplication(msalConfig);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <App instance={msalInstance} />
  </Provider>
);

reportWebVitals();
